export const useRecaptchaStore = defineStore("recaptcha", () => {
    const token = ref("");

    return {token};
});